import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["conditions", "template"];

  addCondition() {
    const conditionNumber = this.conditionsTarget.querySelectorAll(".condition").length;
    const condition = this.templateTarget.content.cloneNode(true);

    const conditionNode = condition.children;
    Array.from(conditionNode).forEach(node => {
      this._assignConditionNumber(node, conditionNumber);
    });

    this.conditionsTarget.appendChild(condition);
  }

  removeCondition(event) {
    const conditionElement = event.target.closest(".condition");
    if (conditionElement) {
      conditionElement.remove();
    }
    this.reindexConditions();

    this.dispatch("conditionRemoved")
  }

  reindexConditions() {
    const conditions = this.conditionsTarget.querySelectorAll(".condition");
    let index = 0;

    conditions.forEach((condition) => {
      index++;
      condition.querySelector(".condition-index").textContent = index;
    });
  }

  _assignConditionNumber(node, conditionNumber) {
    // Assign children before replacing innerHTML to avoid changing nested attributes
    this._assignConditionNumberToChildren(node, conditionNumber);
    this._assignConditionNumberToAttributes(node, conditionNumber);
    this._assignConditionNumberToInnerHTML(node, conditionNumber);
  }

  _assignConditionNumberToAttributes(node, conditionNumber) {
    node.getAttributeNames().forEach(name => {
      const value = node.getAttribute(name);
      let placeholder = /\[?_{2,}id_{2,}\]?/;
      let replace = "__id__";

      if (value.match(placeholder)) {
        node.setAttribute(name, value.replace(replace, conditionNumber));
      }
    });
  }

  _assignConditionNumberToInnerHTML(node, conditionNumber) {
    if (node.innerHTML.includes("___id___")) {
      node.innerHTML = node.innerHTML.replace("___id___", conditionNumber + 1);
    }
  }

  _assignConditionNumberToChildren(node, conditionNumber) {
    if (node.children.length) {
      Array.from(node.children).forEach(child => {
        this._assignConditionNumber(child, conditionNumber);
      });
    }
  }
}
